import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { motion, useInView } from "framer-motion";
import Step1Icon from "../Common/Icons/Feature/Step1Icon";
import Step2Icon from "../Common/Icons/Feature/Step2Icon";
// import ArrowIcon from "../Common/Icons/Feature/ArrowIcon";

export default function Feature() {
  const { t } = useTranslation();
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });

  const steps = [
    {
      icon: Step1Icon,
      text: t('feature.step1')
    },
    {
      icon: Step2Icon,
      text: t('feature.step2')
    },
    {
      icon: Step2Icon,
      text: t('feature.step3')
    }
  ];

  return (
    <div className="px-6 md:py-16 py-10 bg-white mx-auto max-w-7xl">
      <div className="flex flex-col gap-16 md:space-x-20 mx-auto max-w-7xl pt-4 px-6 md:pt-0 lg:px-8 text-center sm:text-start">
        <div className="mx-auto max-w-lg lg:mx-0 flex flex-col relative gap-3 sm:gap-0">
          <div className="hidden absolute right-5 -top-16 md:flex justify-center sm:justify-end order-3">
            {/* <ArrowIcon />*/}
          </div>
          <h2 ref={ref} className="tracking-tight text-[#201D33] text-2xl sm:text-3xl md:text-4xl order-1 font-brave-hunter">
            {t('feature.programInOneClick')}{' '}
            <span className="relative inline-block">
              {/* Fondo animado que barre de izquierda a derecha */}
              <motion.span
                className="absolute inset-0 rounded-md"
                style={{
                  transformOrigin: 'left center',
                  background: '#fef3e2',
                  border: '2px dashed #f5a623',
                }}
                initial={{ scaleX: 0 }}
                animate={inView ? { scaleX: 1 } : { scaleX: 0 }}
                transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: 0.85 }}
              />
              {/* Puntos en las esquinas */}
              {[
                { top: 1, left: 1, x: '-50%', y: '-50%' },
                { top: 1, right: 1, x: '50%',  y: '-50%' },
                { bottom: 1, left: 1, x: '-50%', y: '50%' },
                { bottom: 1, right: 1, x: '50%',  y: '50%' },
              ].map((pos, i) => (
                <motion.span
                  key={i}
                  className="absolute block rounded-full"
                  style={{
                    width: 7,
                    height: 7,
                    background: '#f5a623',
                    ...pos,
                    transform: `translate(${pos.x}, ${pos.y})`,
                  }}
                  initial={{ opacity: 0, scale: 0 }}
                  animate={inView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0 }}
                  transition={{ duration: 0.2, delay: 0.85 + i * 0.1 }}
                />
              ))}
              {/* Texto que cambia de color tras el barrido */}
              <motion.span
                className="relative z-10 px-1"
                initial={{ color: '#201D33' }}
                animate={inView ? { color: '#187672' } : { color: '#201D33' }}
                transition={{ duration: 0.15, delay: 0.85 }}
              >
                {t('feature.programInOneClickHighlight')}
              </motion.span>
            </span>
          </h2>
        </div>
        <div className="flex justify-center max-w pt-8 xl:pt-0">
          {/* Stack vertically on mobile to avoid horizontal overflow, align in a row from md+ */}
          <div className="flex flex-col md:flex-row gap-6 md:gap-8 items-center">
            {steps.map((step, index) => (
              <div key={index} className="bg-white flex flex-col items-center md:items-start gap-4 w-full md:w-auto">
                <div className="flex-shrink-0 w-16 h-16 md:w-20 md:h-20 flex items-center justify-center bg-white rounded-2xl border-gray-100 border-2 shadow-2xl">
                  <step.icon className="p-2 w-8 h-8 md:w-10 md:h-10 " />
                </div>
                <p className="flex-1 text-base md:text-lg font-semibold text-[#201D33] max-w-xs pt-2 text-center md:text-left">
                  {step.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
